import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    selectedTasks: [],
    isDirty: false
};
export const sprintsSlice = createSlice({
    name: 'sprints',
    initialState,
    reducers: (create)=>({
            setSelectedTasks: create.reducer((state, action)=>{
                return {
                    ...state,
                    selectedTasks: [
                        ...action.payload
                    ]
                };
            }),
            setDirty: create.reducer((state)=>{
                return {
                    ...state,
                    isDirty: true
                };
            }),
            resetDirty: create.reducer((state)=>{
                return {
                    ...state,
                    isDirty: false
                };
            })
        })
});
export const sprintsReducer = sprintsSlice.reducer;
export const stateName = sprintsSlice.name;
